import cn from "classnames";
import { FC, HTMLAttributes, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ChangeCurrentBatch, ClearCurrentBatch, ClearPaginationData } from "toolkit/steps/stepSix/stepSix.slice";
import { IBatch } from "toolkit/steps/stepSix/stepSix.types";
import styles from "./Batches.module.sass";

interface BatchesProps extends HTMLAttributes<HTMLDivElement> {}

export const Batches: FC<BatchesProps> = ({ className }) => {
	const { batchList, currentBatch } = useAppSelector((state) => state.stepSix);
	const location = useLocation();
	const dispatch = useAppDispatch();
	useEffect(() => {
		if (location.state && location.state?.outline && batchList.length) {
			const batch = batchList.find((_) => _.id === location.state?.outline);
			location.state.outline = null;
			dispatch(ChangeCurrentBatch(batch ? batch : batchList[0]));
		} else {
			if (batchList.length && !currentBatch) dispatch(ChangeCurrentBatch(batchList[0]));
		}

		return () => {
			dispatch(ClearCurrentBatch());
		};
		//eslint-disable-next-line
	}, [batchList, location.state]);

	const changingBatchHandler = (batch: IBatch) => {
		if (currentBatch?.id === batch.id) return;
		dispatch(ClearPaginationData({ clearBatches: true }));
		dispatch(ChangeCurrentBatch(batch));
	};

	return (
		<div data-comment-false={true} className={cn(styles.batches, className)}>
			<div className={styles["title-wrp"]}>
				<span className={styles.title}>Партии документов</span>
			</div>
			<div className={styles["batches-list-wrp"]}>
				<ul className={styles["batches-list"]}>
					{batchList.length > 1 && (
						<li
							onClick={() => changingBatchHandler({ id: 0, name: "Все партии" })}
							className={styles["batches-list-item"]}>
							<input className="none" type="radio" id={`batch-all`} name="batches" />
							<label className={styles.label} htmlFor={`batch-all`}>
								Все партии
							</label>
						</li>
					)}
					{batchList.map((batch, i) => (
						<li onClick={() => changingBatchHandler(batch)} key={batch.id} className={styles["batches-list-item"]}>
							<input
								checked={batch.id === currentBatch?.id}
								readOnly
								className="none"
								type="radio"
								id={`batch-${batch.id}`}
								name="batches"
							/>
							<label className={styles.label} htmlFor={`batch-${batch.id}`}>
								{batch.name}
							</label>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};
